/**
 * 会员任务
 */
import { VIP_TASK } from '../types';

export default {
    name: `${ VIP_TASK}`,
    path: '/vipTask',
    component: () => import(/* webpackChunkName: 'serviceAd' */ '@/views/vipTask/'),
    redirect: { name: `${ VIP_TASK}Index` },
    meta: {
        title: '会员任务',
        savedPosition: { x: 0, y: 0 },
    },
    children: [
        {
            name: `${VIP_TASK}Index`,
            path: 'index',
            component: () => import(/* webpackChunkName: 'serviceAd' */ '@/views/vipTask/home/Home.vue'),
        },
    ],
};
